import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'obc-modal-alerta',
  templateUrl: './modal-alerta.component.html',
  styleUrls: ['./modal-alerta.component.scss'],
})
export class ModalAlertaComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { titulo: string; mensagem: string },
    private bottomSheetRef: MatBottomSheetRef<ModalAlertaComponent>
  ) {}

  fecharModal() {
    this.bottomSheetRef.dismiss();
  }
}
